<template>
  <v-card class="card_setting">
    <v-card>
      <v-card-title>
        <v-avatar tile size="36" class="mr-4">
          <v-img :src="require('@/assets/icon/translation.svg')"></v-img>
        </v-avatar>
        <h1>ภาษา</h1>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="ค้นหา"
          single-line
          hide-details
          clearable
          solo
          dense
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="master_data"
        :search="search"
        id="table-text"
        class="elevation-1"
      >
        <template v-slot:top style="font-size:30px;">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  class="mb-2 bg_btn_gradient"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-plus-circle</v-icon>
                  <span class="text_body_6 mt-1">เพิ่มภาษา</span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text_title_2">{{ formTitle }}</span>
                </v-card-title>
                <v-form ref="form" @submit.prevent="save">
                  <v-card-text class="py-0">
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="10" class align="center" justify="center">
                          <v-avatar tile size="40">
                            <v-img
                              v-if="flag"
                              :src="require('@/assets/flag/' + flag)"
                              :title="formatTitleImg(flag)"
                            ></v-img>
                            <v-img
                              v-else
                              :src="require('@/assets/icon/flag.svg')"
                            ></v-img>
                          </v-avatar>
                        </v-col>
                        <v-col cols="12" align="center">
                          <v-btn
                            v-if="require_flag"
                            outlined
                            color="error"
                            @click="openDialogFlag"
                          >
                            <span class="text_body_5">เลือกธงชาติ</span>
                          </v-btn>
                          <v-btn
                            color="secondary"
                            v-else-if="!flag"
                            @click="openDialogFlag"
                          >
                            <span class="text_body_5">เลือกธงชาติ</span>
                          </v-btn>
                          <v-btn
                            color="secondary"
                            v-else-if="flag"
                            @click="openDialogFlag"
                          >
                            <span class="text_body_5">เปลี่ยนธงชาติ</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-card outlined>
                        <v-row justify="center">
                          <v-col cols="10" class="pb-0">
                            <v-row justify="center">
                              <v-col class="py-0" cols="12" sm="8" md="8">
                                <!-- <pre>{{language_en}}</pre> -->
                                <v-autocomplete
                                  v-model="language_en"
                                  :items="language_list"
                                  dense
                                  outlined
                                  placeholder="เลือกภาษา"
                                  return-object
                                  :item-text="
                                    (item) =>
                                      `${item.name} - ${item.nativeName}`
                                  "
                                  :rules="rule_empty_dropdown"
                                >
                                  <template v-slot:item="data">
                                    <template
                                      v-if="typeof data.item !== 'object'"
                                    >
                                      <v-list-item-content
                                        v-text="data.item"
                                      ></v-list-item-content>
                                    </template>
                                    <template v-else>
                                      <v-list-item-content>
                                        <v-list-item-title
                                          id="autocomplete_list_item_title"
                                          v-html="data.item.name"
                                        ></v-list-item-title>
                                        <v-list-item-subtitle
                                          id="autocomplete_list_item_subtitle"
                                          v-html="data.item.nativeName"
                                        ></v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" class="py-0" sm="4" md="4">
                                <v-text-field
                                  v-model="language_short_en"
                                  outlined
                                  dense
                                  single-line
                                  readonly
                                  placeholder="ชื่อย่อภาษาอังกฤษ"
                                  :rules="rule_empty_textfield"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col cols="10" class="py-0">
                            <v-row justify="center">
                              <v-col cols="12" class="py-0" sm="8" md="8">
                                <v-text-field
                                  v-model="language_th"
                                  outlined
                                  dense
                                  single-line
                                  placeholder="ชื่อภาษาไทย"
                                  :rules="rule_th_language"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" class="py-0" sm="4" md="4">
                                <v-text-field
                                  v-model="language_short_th"
                                  outlined
                                  dense
                                  single-line
                                  placeholder="ชื่อย่อภาษาไทย"
                                  :rules="rule_th_language_short"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      <h4>ยกเลิก</h4>
                    </v-btn>
                    <v-btn color="blue darken-1" text type="submit">
                      <h4>บันทึก</h4>
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }"
          >{{ master_data.indexOf(item) + 1 }}.</template
        >
        <template v-slot:item.languagePathImg="{ item }">
          <v-avatar tile size="32">
            <v-img
              v-if="item.languagePathImg"
              :src="require('@/assets/flag/' + item.languagePathImg)"
              :title="formatTitleImg(item.languagePathImg)"
            ></v-img>
          </v-avatar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data></template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog_flag" max-width="700px">
      <v-card tile>
        <v-container>
          <v-row justify="center" align="center">
            <v-col
              justify="center"
              align="center"
              cols="4"
              sm="3"
              md="2"
              v-for="item in files"
              :key="item"
            >
              <v-card
                class="text-center"
                tile
                hover
                flat
                @click="selectFlag(item)"
              >
                <v-avatar tile>
                  <v-img
                    class="elevation-4"
                    :src="require('@/assets/flag/' + item)"
                    :title="formatTitleImg(item)"
                  ></v-img>
                </v-avatar>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { getLanguage } from "./LanguageList.js";
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      language_th: null,
      language_en: null,
      flag: null,
      language_short_th: null,
      language_short_en: null,
      rule_empty_textfield: rules.isEmptyTextField,
      rule_empty_dropdown: rules.isEmptyDropdown,
      rule_th_language: rules.th_language,
      rule_th_language_short: rules.th_language_short,
      rule_en_language: rules.en_language,
      rule_en_language_short: rules.en_language_short,
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      api_url: "api/v1/masterdata/language",
      dialog: false,
      dialog_flag: false,
      search: "",
      headers: [
        {
          text: "ลำดับ",
          sortable: false,
          value: "no",
        },
        {
          text: "ธงชาติ",
          value: "languagePathImg",
          sortable: false,
          width: "10%",
          align: "center",
        },
        {
          text: "ชื่อย่อ (ภาษาไทย)",
          value: "languageShortName",
          sortable: false,
          width: "10%",
        },
        {
          text: "ชื่อภาษาไทย",
          value: "languageName",
          sortable: false,
          width: "15%",
        },
        {
          text: "ชื่อย่อ (ภาษาอังกฤษ)",
          value: "languageShortNameEn",
          sortable: false,
          width: "10%",
        },
        {
          text: "ชื่อภาษาอังกฤษ",
          value: "languageNameEn",
          sortable: false,
          width: "15%",
        },
        {
          text: "ชื่อภาษา (Native)",
          value: "languageNative",
          sortable: false,
          width: "30%",
        },

        { text: "จัดการ", value: "actions", sortable: false, width: "20%" },
      ],
      require_flag: false,
      editedIndex: -1,
      files: [],
      master_data: [],
      language_list: [],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่มภาษา" : "แก้ไขภาษา";
    },
    disabled() {
      return this.editedIndex === -1 ? false : true;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    flag(val) {
      if (val) {
        this.require_flag = false;
      }
    },
    language_en(val) {
      // console.log(val);
      if (val) {
        this.language_short_en = val.code.toUpperCase();
      }
    },
  },

  created() {
    const module_name = "permission_setting";
    const func_name = "language";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        this.initialMethod();
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },

  methods: {
    initialMethod() {
      const flag = require.context("@/assets/flag/");
      var all_flag = flag.keys();
      var all_files = [];
      all_flag.forEach((element) => {
        var flag = element.replace("./", "");
        all_files.push(flag);
      });
      this.files = all_files;
      this.language_list = getLanguage();

      this.getMasterData();
    },
    getMasterData() {
      this.axios
        .get(process.env.VUE_APP_API + this.api_url, this.header_token)
        .then((res) => {
          this.master_data = res.data;
        });
    },

    post() {
      var data = {
        languageName: this.language_th,
        languageNameEn: this.language_en.name,
        languageNative: this.language_en.nativeName,
        languagePathImg: this.flag,
        languageShortName: this.language_short_th,
        languageShortNameEn: this.language_short_en,
      };

      this.axios
        .post(process.env.VUE_APP_API + this.api_url, data, this.header_token)
        .then((res) => {
          if (res.data.message == "create success") {
            this.$swal.fire({
              icon: "success",
              title: "บันทึกข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    put() {
      var data = {
        languageName: this.language_th,
        languageNameEn: this.language_en.name,
        languageNative: this.language_en.nativeName,
        languagePathImg: this.flag,
        languageShortName: this.language_short_th,
        languageShortNameEn: this.language_short_en,
      };
      var id = this.master_data[this.editedIndex].languageId;
      this.axios
        .put(
          process.env.VUE_APP_API + this.api_url + "/" + id,
          data,
          this.header_token
        )
        .then((res) => {
          if (res.data == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    deleteItem(item) {
      var id = item.languageId;
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value == true) {
            this.axios
              .delete(
                process.env.VUE_APP_API + this.api_url + "/" + id,
                this.header_token
              )
              .then((res) => {
                if (res.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบข้อมูลสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getMasterData();
                }
              });
          }
        });
    },

    editItem(item) {
      this.language_en = {
        name: item.languageNameEn,
        nativeName: item.languageNative,
      };
      this.language_th = item.languageName;
      this.language_short_th = item.languageShortName;
      this.language_short_en = item.languageShortNameEn;
      this.flag = item.languagePathImg;
      this.editedIndex = this.master_data.indexOf(item);
      this.dialog = true;
    },

    close() {
      this.flag = null;
      this.require_flag = false;
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.flag) {
          if (this.$refs.form.validate()) {
            this.put();
            this.close();
          }
        } else if (!this.flag) {
          if (this.$refs.form.validate() && this.flag) {
            this.put();
            this.close();
          } else {
            this.require_flag = true;
          }
        }
      } else {
        if (this.flag) {
          if (this.$refs.form.validate()) {
            this.post();
            this.close();
          }
        } else if (!this.flag) {
          if (this.$refs.form.validate() && this.flag) {
            this.post();
            this.close();
          } else {
            this.require_flag = true;
          }
        }
      }
    },
    selectFlag(item) {
      this.flag = item;
      this.dialog_flag = false;
    },
    openDialogFlag() {
      this.dialog_flag = true;
    },
    formatTitleImg(name) {
      var format = name.replace(".svg", "");
      return format;
    },
  },
};
</script>
